"use client";

import * as React from "react";

/**
 * 시험장 찾기 전용 셸 슬롯 컨텍스트 (JCG-2100).
 *
 * ArticleShell 의 ArticleShellContext 와 동일한 패턴: 셸이 우측 사이드바에 portal 타깃 div 를
 * 두고 그 DOM element 만 컨텍스트로 내려주면, 본문(TestCenterContent)이 카드+RedAlert+배너를
 * 우측 슬롯으로 createPortal 한다. 좌측은 지도를 넓게 쓰기 위해 아이콘 레일(58px)만 남기고
 * 콘텐츠 컬럼을 두지 않는다. 셸 밖(모바일/클래식)에서는 Provider 가 없어 inShell:false →
 * 단일 컬럼으로 전부 흐름 렌더된다.
 */
export interface TestCenterShellSlots {
  inShell: boolean;
  rightSlot: HTMLElement | null;
}

const TestCenterShellContext = React.createContext<TestCenterShellSlots>({
  inShell: false,
  rightSlot: null,
});

export function useTestCenterShellSlots(): TestCenterShellSlots {
  return React.useContext(TestCenterShellContext);
}

export default TestCenterShellContext;
